import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const TimeIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.8991 6.94955C12.8991 6.42513 12.474 6 11.9496 6C11.4251 6 11 6.42513 11 6.94956V12.3304L15.653 15.0917C16.0761 15.3428 16.6226 15.2037 16.8742 14.7809C17.1261 14.3576 16.987 13.8102 16.5635 13.5585L12.8991 11.3808V6.94955Z"
      />
    </Icon>
  );
};
